import React, { useState } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { Container, Typography, Button,Box,Stack, TextField,FormControl,MenuItem,InputLabel,Select } from '@mui/material';
import fascicoloApi from '../../api/fascicoloApi';
import ProtectedAction from '../../components/ProtectedAction';
import BackButtonDesktop from '../../components/BackButtonDesktop';
const tipiDocumento = [
    'DOCUMENTO_IDENTITA',
    'CONTRATTO',
    'UNICO',
    'MULTA',
    'PAGOPA',
    'ATTO_SOCIETARIO',
    'BANCARIO',
    'RATEIZZAZIONE_ADE',
    'ROTTAMAZIONE',
    'AMA',
    'ACCERTAMENTO_TARI',
    'F24',
    'FF24PREDETERMINATO',
    'TARI',
    'INTIMAZIONEPAG_AGRISC',
    'BOLLOAUTO',
    'INARCASSA',
    'ALTRO'
];
export default function CreateDocumentoFascicoloPage() {
  const { fascicoloId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [file, setFile] = useState(null);
  const [descrizione, setDescrizione] = useState('');
  const [versione, setVersione] = useState('');
  const { richiestaId,tipo } = location.state || {};
    const [tipoDocumento, setTipoDocumento] = useState(tipo);
  //const richiestaId = location.state?.richiestaId;
  console.log("richiestaId",richiestaId);
  console.log("tipo",tipo);
  const handleUpload = async () => {
    if (!file) return;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('descrizione', descrizione);
    formData.append('versione', versione);
    formData.append('tipoDocumento', tipoDocumento); // qui lo invii al backend
    if (richiestaId) formData.append('richiestaId', richiestaId);

    try {
      await fascicoloApi.uploadDocumento(fascicoloId, formData);
      navigate(-1); // torna alla pagina del fascicolo
    } catch (err) {
      console.error(err);
    }
  };

    const handleFileChange = (e) => {
      if (e.target.files && e.target.files.length > 0) {
        setFile(e.target.files[0]);
      }
    };

  return (
    <Container>
    <BackButtonDesktop />
      <Typography variant="h5" sx={{ mb: 2 }}>
        Carica Documento nel Fascicolo
      </Typography>
      <FormControl fullWidth sx={{ mt: 2 }}>
        <InputLabel>Tipo Documento</InputLabel>
        <Select
          value={tipoDocumento}
          onChange={e => setTipoDocumento(e.target.value)}
          label="Tipo Documento"
        >
          {tipiDocumento.map(t => (
            <MenuItem key={t} value={t}>{t}</MenuItem>
          ))}
        </Select>
      </FormControl>
      <TextField
        label="Descrizione Documento"
        value={descrizione}
        onChange={(e) => setDescrizione(e.target.value)}
        fullWidth
        sx={{ mb: 2 }}
      />
    <TextField
      label="Versione"
      type="number"
      value={versione}
      onChange={(e) => setVersione(e.target.value)}
      fullWidth
      sx={{ mb: 2 }}
    />
{/* FILE UPLOAD */}
<Box sx={{ mt: 2 }}>
  <input
    accept="application/pdf"
    style={{ display: 'none' }}
    id="contained-button-file"
    type="file"
    onChange={handleFileChange}
  />

  <label htmlFor="contained-button-file">
    <Button variant="outlined" component="span">
      {file ? 'Cambia PDF' : 'Sfoglia PDF'}
    </Button>
  </label>

  {file && (
    <Typography variant="body2" sx={{ mt: 1 }}>
      {file.name}
    </Typography>
  )}
</Box>
      <Button variant="contained" sx={{ mt: 2 }} onClick={handleUpload}>
        Carica Documento
      </Button>
    </Container>
  );
}